import React, { useEffect, useState } from "react";
import { useCart } from "./CartContext";
import { useNavigate, Link } from "react-router-dom";
import accountSvg from "../assets/images/account.svg";
import userIcon from "../assets/images/svg/user.svg";
import locationIcon from "../assets/images/svg/location.svg";
import walletAddIcon from "../assets/images/svg/wallet-add.svg";
import verifyIcon from "../assets/images/svg/verify.svg";
import dotsDesign from "../assets/images/svg/dots-design.svg"; // Corrected the file name

const Checkout = () => {
    const { cart, removeFromCart } = useCart();
    const navigate = useNavigate();
    const [promoCode, setPromoCode] = useState(''); // Promo code state
    const [discount, setDiscount] = useState(0); // Discount state
    const [quantities, setQuantities] = useState({}); // Quantity state

    useEffect(() => {
        // Store the cart in localStorage whenever it changes
        localStorage.setItem("cart", JSON.stringify(cart));

        const initialQuantities = {};
        cart.forEach(item => {
            initialQuantities[item._id] = item.quantity;
        });
        setQuantities(initialQuantities);
    }, [cart]);

    const calculateSubtotal = () => {
        return cart.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2);
    };

    const calculateTotal = () => {
        const subtotal = parseFloat(calculateSubtotal());
        const discountedTotal = subtotal - discount; // Apply discount directly to subtotal

        return discountedTotal.toFixed(2);
    };

    const handlePromoCodeApply = () => {
        if (promoCode === 'DISCOUNT10') {
            const subtotal = parseFloat(calculateSubtotal());
            const discountAmount = Math.min(subtotal * 0.1, 10); // 10% discount, up to $10
            setDiscount(discountAmount);
        } else {
            setDiscount(0);
            alert('Code promo invalide.');
        }
    };

    const removeItem = (item) => {
        removeFromCart(item._id, item.ownerId, item.category);
    };

    const handleQuantityChange = (itemId, change) => {
        const item = cart.find(item => item._id === itemId);
        if (!item) return;

        const newQuantity = Math.max(1, (quantities[itemId] || item.quantity) + change);  // Ensure quantity is at least 1

        setQuantities(prevQuantities => ({
            ...prevQuantities,
            [itemId]: newQuantity
        }));
    };

    return (
        <div className="main-container">
            <header className="header">
                <div className="container">
                    <div className="header-content">
                        <div className="header-logo">Lememeprix</div>
                        <div className="header-actions">
                            <div className="cart-badge">
                                <i className="fa-solid fa-cart-shopping"></i>
                                <span className="badge">{cart.length}</span>
                            </div>
                            <img src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg" alt="Profile" className="profile-image" />
                        </div>
                    </div>
                </div>
            </header>

            <main className="main-content">
                <div className="container">
                    <section className="cart-header">
                        <h1 className="cart-title">Votre Panier</h1>
                        <p className="cart-items-count">{cart.length} articles dans votre panier</p>
                    </section>

                    <section className="cart-items">
                        {cart.map(item => (
                            <div key={item._id} className="cart-item">
                                <img className="cart-item-image" src={item.itemImg} alt={item.itemName} />
                                <div className="cart-item-details">
                                    <h3 className="food-title">{item.itemName}</h3>
                                    <p className="food-description">Burger classique au bœuf avec fromage</p>
                                </div>
                                <div className="cart-item-actions">
                                    <div className="quantity-controls">
                                        <button onClick={() => handleQuantityChange(item._id, -1)} className="quantity-button">
                                            <i className="fa-solid fa-minus"></i>
                                        </button>
                                        <span className="quantity">{quantities[item._id] || item.quantity}</span>
                                        <button onClick={() => handleQuantityChange(item._id, 1)} className="quantity-button">
                                            <i className="fa-solid fa-plus"></i>
                                        </button>
                                    </div>
                                    <button onClick={() => removeItem(item)} className="remove-button">
                                        <i className="fa-solid fa-trash"></i>
                                        <span>Supprimer</span>
                                    </button>
                                </div>
                                <div className="food-price">€{item.price * (quantities[item._id] || item.quantity)}</div>
                            </div>
                        ))}
                    </section>

                    <section className="cart-summary">
                        <div className="summary-box">
                            <h2 className="summary-title">Résumé de la commande</h2>
                            <div className="summary-details">
                                <div className="detail">
                                    <span>Sous-total</span>
                                    <span>€{calculateSubtotal()}</span>
                                </div>
                                {/* <div className="detail">
                                    <span>Delivery Fee</span>
                                    <span>€2.99</span>
                                </div> */}
                                <div className="detail total">
                                    <span>Total</span>
                                    <span>€{calculateTotal()}</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </main>

            <div className="checkout-button-container">
                <button className="checkout-button" onClick={() => navigate("/payment")}>Passer à la caisse</button>
            </div>

            <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <h3 className="footer-title">Liens rapides</h3>
                            <ul className="footer-links">
                                <li><span className="footer-link">À propos de nous</span></li>
                                <li><span className="footer-link">Contact</span></li>
                                <li><span className="footer-link">Politique de confidentialité</span></li>
                            </ul>
                        </div>
                        <div className="footer-section">
                            <h3 className="footer-title">Assistance</h3>
                            <p className="contact-info">Besoin d'aide ? Contactez-nous à</p>
                            <p className="contact-info">support@lememeprix.com</p>
                        </div>
                        <div className="footer-section">
                            <h3 className="footer-title">Suivez-nous</h3>
                            <div className="social-icons">
                                <a href="#" className="social-icon">
                                    <i className="fa-brands fa-instagram"></i>
                                </a>
                                <a href="#" className="social-icon">
                                    <i className="fa-brands fa-facebook"></i>
                                </a>
                                <a href="#" className="social-icon">
                                    <i className="fa-brands fa-twitter"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <style jsx>{`
                 /* Main Container */
                .main-container {
                    min-height: 100vh;
                    background-color: #fff;
                    display: flex;
                    flex-direction: column;
                }

                /* Header */
                .header {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    background-color: #fff;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    z-index: 50;
                }

                .header .container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 1rem;
                }

                .header-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 1rem;
                }

                .header-logo {
                    font-size: 1.5rem;
                    font-weight: bold;
                }

                   .location-input {
        position: relative;
        flex: 1;
        margin: 0 1rem;
    }
                .header-actions {
                     display: flex;
                     align-items: center;
                     gap: 1rem;
                }

            /* Cart Badge */
            .cart-badge {
             position: relative;
                cursor: pointer;
              }

            .cart-badge i {
                 font-size: 1.5rem;
              }

           .cart-badge .badge {
                position: absolute;
                top: -0.5rem;
                right: -0.5rem;
                background-color: #ef4444;
                color: #fff;
                font-size: 0.75rem;
                width: 1.25rem;
                height: 1.25rem;
                border-radius: 9999px;
                display: flex;
                 align-items: center;
                 justify-content: center;
}
            /* Profile Image */
            .profile-image {
                 width: 3rem;
                 height: 3rem;
                 border-radius: 9999px;
                object-fit: cover;
}
            /* Main Content */
            .main-content {
                padding-top: 5rem;
                flex: 1; /* Allow main to grow and push footer to the bottom */
            }

            /* Container */
            .container {
                max-width: 1200px;
                margin: 0 auto;
                padding: 0 1rem;
            }

            /* Cart Header */
            .cart-header {
                padding: 2rem 0;
            }

            .cart-title {
                font-size: 2rem;
                font-weight: bold;
                margin-bottom: 0.5rem;
            }

            .cart-items-count {
                color: #6b7280;
            }

            /* Cart Items */
            .cart-items {
                display: flex;
                flex-direction: column;
                gap: 1.5rem;
                margin-bottom: 2rem;
            }

            .cart-item {
                 background-color: #fff;
                border-radius: 0.75rem;
                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
                 padding: 1.5rem;
                display: flex;
                align-items: center;
                gap: 1.5rem;
                transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
            }

            .cart-item:hover {
                transform: scale(1.02);
                box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
            }

            .cart-item-image {
                width: 8rem;
                height: 8rem;
                border-radius: 0.5rem;
                overflow: hidden;
                flex-shrink: 0;
            }

            .cart-item-image img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .cart-item-details {
                flex: 1;
            }

            .food-title {
                font-size: 1.25rem;
                font-weight: bold;
                margin-bottom: 0.25rem;
            }

            .food-description {
                color: #6b7280;
                font-size: 0.875rem;
            }

             .food-price {
                font-size: 1.125rem;
                font-weight: bold;
                color: #ef4444;
            }

               .remove-button {
            background: none;
            border: none;
            color: #ef4444;
            cursor: pointer;
            transition: color 0.2s ease-in-out;
        }

                 .cart-item-actions {
                display: flex;
                align-items: center;
                gap: 1rem;
                  }

        .quantity-controls {
        display: flex;
         align-items: center;
                }

                 .quantity-button {
                   background-color: #fff;
                    border: 1px solid #d1d5db;
                      border-radius: 0.375rem;
                         padding: 0.5rem;
                cursor: pointer;
                  transition: border-color 0.2s ease-in-out;
}

              .quantity {
                  font-weight: bold;
                   font-size: 1rem;
                    margin: 0 0.5rem;
                }

            /* Order Summary */
             .order-summary {
              max-width: 30rem;
                    margin-left: auto;
                }

                 .summary-box {
                    background-color: #f3f4f6;
                       border-radius: 0.75rem;
                   padding: 2rem;
        }

        .summary-title {
        font-size: 1.5rem;
        font-weight: bold;
        margin-bottom: 1rem;
            }

             .summary-details {
                 margin-bottom: 1.5rem;
                 }
              .detail {
                display: flex;
                 justify-content: space-between;
                   margin-bottom: 0.75rem;
                 color: #374151;
                  }

                   .total {
                    font-weight: bold;
                  font-size: 1.25rem;
                        padding-top: 1rem;
               border-top: 2px solid #e5e7eb;
              }
               /* Floating Checkout Button */
        .checkout-button-container {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: #fff;
            box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
        }

        .checkout-button-container .container {
             padding-top: 1rem;
            padding-bottom: 1rem;
                }
                .checkout-button {
        width: 100%;
        padding: 1rem;
        border-radius: 0.75rem;
        background-color: #1f2937;
        color: #fff;
         text-align: center;
               font-weight: bold;
                text-decoration: none;
                transition: background-color 0.2s ease-in-out;
        }

        .checkout-button:hover {
        background-color: #374151;
            }

            /* Footer */
            .footer {
                background-color: #f9fafb;
                padding: 3rem 0;
                margin-top: 4rem;
            }

            .footer .container {
                max-width: 1200px;
                margin: 0 auto;
                padding: 0 1rem;
            }

            .footer-content {
                display: grid;
                grid-template-columns: repeat(1, 1fr);
                gap: 2rem;
            }

            @media (min-width: 768px) {
                .footer-content {
                    grid-template-columns: repeat(3, 1fr);
                }
            }

            .footer-section {
                display: flex;
                flex-direction: column;
            }

            .footer-title {
                font-size: 1.25rem;
                font-weight: bold;
                margin-bottom: 1rem;
            }

            .footer-links {
                list-style: none;
                padding: 0;
            }

            .footer-links li {
                margin-bottom: 0.5rem;
            }

            .footer-link {
                color: #4b5563;
                cursor: pointer;
                transition: color 0.2s ease;
                text-decoration: none;
            }

            .footer-link:hover {
                color: #6b7280;
            }

            .social-icons {
                display: flex;
                gap: 1rem;
            }

            .social-icons i {
                font-size: 1.5rem;
                color: #4b5563;
                cursor: pointer;
                transition: color 0.2s ease;
            }

            .social-icons i:hover {
                color: #6b7280;
            }

            .contact-info {
                display: flex;
                flex-direction: column;
            }

            .contact-details {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                margin-bottom: 0.5rem;
                color: #4b5563;
            }
             @media (max-width: 767px) {
            .order-summary {
                max-width: 100%; /* Make the order summary full-width on smaller screens */
            }
        }
            `}</style>
        </div>
    );
};

export default Checkout;